export interface Waypoint {
  id: string;
  name: string;
  lngLat: [number, number];
  poiId: string | null;
  userpoint: boolean;
  /** True when waypoint came from a tracked route (e.g. API); app-created waypoints are always false. */
  tracked: boolean;
  routingMode: "auto" | "manual";
  distance: number;
  passage: Array<{
    type: "Feature";
    properties: { distance: number; [key: string]: unknown };
    geometry: {
      type: "LineString";
      coordinates: number[][];
    };
  }>;
}

export function routeTotalDistance(waypoints: Waypoint[]): number {
  if (!waypoints || !Array.isArray(waypoints)) return 0;

  let distance = 0;

  for (const wp of waypoints) {
    if (!wp.passage || !Array.isArray(wp.passage)) continue;

    for (const p of wp.passage) {
      distance += p.properties.distance || 0;
    }
  }

  return distance;
}
